import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaPlay, FaRocket, FaCode, FaMobile } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="gradient-overlay"></div>
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>

      <div className="container">
        <div className="hero-content">
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <motion.span
              className="hero-badge"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              🚀 Leading IT Solutions Provider
            </motion.span>

            <motion.h1
              className="hero-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              Transform Your Business with
              <span className="gradient-text"> Cutting-Edge Technology</span>
            </motion.h1>

            <motion.p
              className="hero-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
            >
              We deliver innovative web applications, mobile solutions, and digital platforms 
              that drive growth and enhance user experiences. From concept to deployment, 
              we're your trusted technology partner.
            </motion.p>

            <motion.div
              className="hero-actions"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1 }}
            >
              <motion.button
                className="primary-button"
                whileHover={{ scale: 1.05}}
                whileTap={{ scale: 0.95 }}
                onClick={() => scrollToSection('contact')}
              >
                Start Your Project
                <FaArrowRight />
              </motion.button>

              <motion.button
                className="secondary-button"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => scrollToSection('portfolio')}
              >
                <FaPlay />
                View Our Work
              </motion.button>
            </motion.div>

            <motion.div
              className="hero-stats"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.2 }}
            >
              <div className="stat">
                <h3>500+</h3>
                <p>Projects Delivered</p>
              </div>
              <div className="stat">
                <h3>250+</h3>
                <p>Happy Clients</p>
              </div>
              <div className="stat">
                <h3>12+</h3>
                <p>Years Experience</p>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            className="hero-visual"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="hero-image-container">
              <div className="floating-card card-1">
                <FaCode />
                <span>Web Development</span>
              </div>
              <div className="floating-card card-2">
                <FaMobile />
                <span>Mobile Apps</span>
              </div>
              <div className="floating-card card-3">
                <FaRocket />
                <span>Digital Solutions</span>
              </div>
              <div className="main-visual">
                <div className="tech-grid">
                  <div className="tech-item">React.js</div>
                  <div className="tech-item">HTML</div>
                  <div className="tech-item">CSS</div>
                  <div className="tech-item">Shopify</div>
                  <div className="tech-item">WordPress</div>
                  <div className="tech-item">Node.js</div>
                  <div className="tech-item">AWS</div>
                  <div className="tech-item">Google Cloud</div>
                  <div className="tech-item">MongoDB</div>
                  <div className="tech-item">Docker</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

